module.exports = __webpack_public_path__ + "img/file-upload.62d7624b.svg";